<template>
	<div class="padding-top padding-bottom content">
		<div class="flex">
			<h1>Edit discount #{{ getId() }}</h1>
			<div class="margin-left">
				<a href="/#/discounts"><button>&#171; Back</button></a>
			</div>
		</div>
		<DiscountEditor class="large-margin-top" :id="getId()" />
	</div>
</template>

<script>
import Vue from 'vue'
import DiscountEditor from '@/components/DiscountEditor.vue'

export default {
  components: {
    DiscountEditor
  },
  methods: {
    getId () {
      return this.$route.params.id
    }
  }
}
</script>
